import { OSSDK } from 'opensolar-sdk'
import { useDataProvider } from 'ra-core'
import { useEffect } from 'react'

const useDataProviderBindings = ({ active, sdk }: { sdk: OSSDK; active: boolean }) => {
  const dataProvider = useDataProvider()

  useEffect(() => {
    if (!active) return

    sdk.dataProvider.getList.own(async (resource, params) => {
      return dataProvider.getList(resource, params)
    })
    sdk.dataProvider.getOne.own(async (resource, params) => {
      return dataProvider.getOne(resource, params)
    })
    sdk.dataProvider.getMany.own(async (resource, params) => {
      return dataProvider.getMany(resource, params)
    })
    sdk.dataProvider.getManyReference.own(async (resource, params) => {
      return dataProvider.getManyReference(resource, params)
    })
    sdk.dataProvider.update.own(async (resource, params) => {
      return dataProvider.update(resource, params)
    })
    sdk.dataProvider.updateMany.own(async (resource, params) => {
      return dataProvider.updateMany(resource, params)
    })
    sdk.dataProvider.create.own(async (resource, params) => {
      return dataProvider.create(resource, params)
    })
    sdk.dataProvider.delete.own(async (resource, params) => {
      return dataProvider.delete(resource, params)
    })
    sdk.dataProvider.deleteMany.own(async (resource, params) => {
      return dataProvider.deleteMany(resource, params)
    })
  }, [active, dataProvider])
}

export default useDataProviderBindings
